import React, {useState} from 'react';
import { formatCurrency } from '../../../data/shared/money';
import PayFormContainer from '../../followup/containers/PayFormContainer';
import {withTranslation} from "react-i18next";
import Modal from "../../shared/components/Modal";

const AcceptionQuotationSuccess = ({ data, onClickClose, t }) => {
    const [open, setOpen] = useState(true);

    const handleCancel = (open) => {
        setOpen(open)
        onClickClose()
    }
    return <Modal open={open} setOpen={handleCancel} title={t('followup.thanks')}>
        <div className="mt-10">
            <p className="mb-6 font-bold">{t('followup.reservation_saved')}</p>
            <p>
                {t('followup.reservation_payment_information')}{' '}
                {data && formatCurrency(data.pricing.totalWithTaxes)}.
            </p>
        </div>
        <p className="mt-5">{t('followup.choice_of_payment_method')}&nbsp;:</p>

        <PayFormContainer/>
    </Modal>
};

export default withTranslation()(AcceptionQuotationSuccess);
